module.exports = __webpack_public_path__ + "static/media/Website and Social Media Links.d6df7156.png";